module.exports = __webpack_public_path__ + "static/hpass-d56f5868317e71f30a01e933c3685725.svg";